import { merge } from 'lodash-es';
import { computed, inject, ref, watch } from 'vue';
import iconSets from '../lib/iconSets.yml';
import { useTheme } from './useTheme';
import { addCollection, getIcon } from '@iconify/iconify';
import type { IconifyJSON } from '@iconify/types';

// let iconifyCollections: IconifyCollections;
try {
  import('/node_modules/.icons/collections.json').then(
    ({ default: collections }) => {
      for (const collection of Object.values(collections) as IconifyJSON[]) {
        addCollection(collection);
      }
    }
  );
} catch (e) {}

console.log(getIcon('map:atm'));

type IconSet = { [name: string]: string };

const legacyThemes = {
  mazars: {
    'theme:right': 'ep:arrow-right',
    'theme:left': 'ep:arrow-left'
  },
  leo: {
    'theme:down': 'akar-icons:arrow-down',
    'theme:up': 'akar-icons:arrow-up'
  },
  xey: {
    'theme:lock': 'bytesize:lock',
    'theme:left': 'cil:arrow-left',
    'theme:right': 'cil:arrow-right',
    'theme:down': 'cil:arrow-bottom',
    'theme:up': 'cil:arrow-top',
    'theme:check': 'mdi:check',
    'theme:error': 'mdi:close',
    'theme:check-circle': 'mdi:check-circle',
    'theme:quote': 'ri:double-quotes-l',
    'theme:audio-on': 'mdi:volume',
    'theme:audio-off': 'mdi:volume-mute'
  },
  'hfw-montserrat': {
    'theme:lock': 'bytesize:lock',
    'theme:left': 'cil:arrow-left',
    'theme:right': 'cil:arrow-right',
    'theme:down': 'cil:arrow-bottom',
    'theme:up': 'cil:arrow-top',
    'theme:check': 'mdi:check',
    'theme:error': 'mdi:close',
    'theme:check-circle': 'mdi:check-circle',
    'theme:quote': 'ri:double-quotes-l',
    'theme:audio-on': 'mdi:volume',
    'theme:audio-off': 'mdi:volume-mute'
  },
  roboto: {
    'theme:lock': 'bytesize:lock',
    'theme:left': 'mdi:arrow-left',
    'theme:right': 'mdi:arrow-right',
    'theme:check': 'mdi:check',
    'theme:error': 'mdi:close',
    'theme:check-circle': 'mdi:check-circle'
  },
  bebas: {
    'theme:lock': 'bytesize:lock',
    'theme:left': 'ic:baseline-keyboard-double-arrow-left',
    'theme:right': 'ic:baseline-keyboard-double-arrow-right',
    'theme:down': 'ic:baseline-keyboard-double-arrow-down',
    'theme:up': 'ic:baseline-keyboard-double-arrow-up',
    'theme:check': 'mdi:check',
    'theme:error': 'mdi:close',
    'theme:check-circle': 'mdi:check-circle',
    'theme:quote': 'fontisto:quote-left'
  },
  rubik: {
    'theme:lock': 'fa6-solid:lock',
    'theme:left': 'fa6-solid:arrow-left',
    'theme:right': 'fa6-solid:arrow-right',
    'theme:check': 'fa6-solid:check',
    'theme:check-circle': 'fa6-solid:circle-check'
  },
  plex: {
    'theme:lock': 'bytesize:lock',
    'theme:left': 'mdi:chevron-left',
    'theme:right': 'mdi:chevron-right',
    'theme:check': 'mdi:check',
    'theme:check-circle': 'mdi:check-circle'
  },
  baskerville: {
    'theme:lock': 'bytesize:lock',
    'theme:left': 'bi:chevron-double-left',
    'theme:right': 'bi:chevron-double-right',
    'theme:check': 'mdi:check',
    'theme:check-circle': 'mdi:check-circle'
  },
  skillboosters: {
    'theme:plus-circle': 'mdi-light:plus-circle',
    'theme:minus-circle': 'mdi-light:minus-circle'
  }
};

const useIcons = () => {
  const recompute = ref(0);

  const themeOptions = useTheme();
  const themeName = inject<Ref<string>>('theme');

  watch([themeOptions], () => recompute.value++, { deep: true });

  const themeIcons = computed<IconSet>(() => {
    recompute.value;

    return merge(
      {},
      iconSets.default,
      iconSets[themeOptions.value['icon-set']],
      themeOptions.value.icons,
      legacyThemes[themeName.value]
    );
  });

  const resolveIcon = (name: string) => themeIcons.value[name] || name;

  return { themeIcons, resolveIcon };
};

export default useIcons;
